/**
 * Maevva: color reveal on touch screens.
 *
 * The black and white photos warm up to full color on hover (see .m-grayscale
 * in maevva.css). Phones have no hover, so here the photo nearest the middle
 * of the screen gets .is-lit as you scroll, one at a time, and loses it again
 * when it moves on. Mouse and trackpad visitors never run this.
 */
(() => {
  const TOUCH = window.matchMedia('(hover: none)');
  const SELECTOR = '.m-grayscale:not(.m-plate)';

  if (!('IntersectionObserver' in window)) return;

  // The middle 20% band of the viewport: a photo is lit while it crosses it.
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-lit', entry.isIntersecting);
      });
    },
    { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
  );

  const scan = (root = document) => {
    if (!TOUCH.matches) return;
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.dataset.colorReveal === 'on') return;
      el.dataset.colorReveal = 'on';
      observer.observe(el);
    });
  };

  const stop = () => {
    observer.disconnect();
    document.querySelectorAll(SELECTOR).forEach((el) => {
      delete el.dataset.colorReveal;
      el.classList.remove('is-lit');
    });
  };

  const sync = () => (TOUCH.matches ? scan() : stop());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  // A section redrawn in the theme editor brings new photos with it.
  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  // Plugging in a mouse, or a tablet switching input, flips which one applies.
  if (typeof TOUCH.addEventListener === 'function') {
    TOUCH.addEventListener('change', sync);
  }
})();
